import { Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, combineLatestWith, switchMap } from 'rxjs';
import { RestService } from '@cumlaude/shared-services';
import { UserService } from '../../services/user.service';
import { BerichtenLijstComponent } from './berichten-lijst/berichten-lijst.component';
import { GedeeldePaginaPersoonMode } from './gedeelde-pagina-persoon.model';

@Component({
	selector: 'app-berichten',
	templateUrl: './berichten.component.html',
	styleUrl: './berichten.component.scss',
	imports: [BerichtenLijstComponent],
})
export class BerichtenComponent {
	protected readonly userService = inject(UserService);
	private readonly restService = inject(RestService);

	protected readonly GedeeldePaginaPersoonMode = GedeeldePaginaPersoonMode;
	protected readonly activeTab = signal(GedeeldePaginaPersoonMode.INBOX);

	private readonly refresh$ = new BehaviorSubject<void>(undefined);

	protected readonly ongelezenAantal = toSignal(
		this.userService.myAccount$.pipe(
			combineLatestWith(this.refresh$),
			switchMap(([account]) => this.restService.getAantalOngelezenBerichten(account))
		),
		{ initialValue: 0 }
	);

	protected herlaadTeller() {
		this.refresh$.next();
	}
}
